define([], function () {
	'use strict';

	/**
	 * ActivationType enum
	 */
	return {
		EID_CLIENT : 'eID-Client',
		BROWSER : 'Browser',
		BROWSER_XHR : 'Browser-XHR'
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/ActivationType.js
// module id = 24
// module chunks = 2